module.exports = __webpack_public_path__ + "media/newstyle/images/icon-has-4317b83c4af753ee65bec8e5e0feadc1.svg";